import type { SwiperContainer } from "swiper/element"

export const galleryModal = (): HTMLElement | null => document.querySelector("#gallery.modal") as HTMLElement | null

export const isGalleryOpen = (): boolean =>
    document.body.classList.contains("modal-open") && (galleryModal()?.classList.contains("in") || false)

export const gallerySlider = (): SwiperContainer | null =>
    galleryModal()?.querySelector(".gallery-slider") as SwiperContainer | null

export const thumbnailSlider = (): SwiperContainer | null =>
    galleryModal()?.querySelector(".thumbnail-slider") as SwiperContainer | null
